`
<script setup>
import {computed, defineEmits, defineProps, nextTick, onMounted, ref, watch} from "vue";
import {useLocales} from "@/composables/locales";
import * as tempusDominus from "@eonasdan/tempus-dominus";
const {locale} = useLocales()

const props =defineProps({
  id: { type: String, default: 'date-range-picker' },
  startDate: String
})
const date = ref(new Date())
const emits = defineEmits(['update:date'])
const year = computed(() => (props?.startDate && props?.startDate !== 'undefined' && props?.startDate !== null && !isNaN(Date.parse(props.startDate))) ? new Date(props?.startDate).getFullYear() : new Date().getFullYear())

watch(() => locale.value, (value) => {
  nextTick(() => {
    moment.locale(locale.value);
    initDatePicker();
  })
}, { deep: true })

function initDatePicker() {
  const button = document.getElementById(props.id)
  if(button) {
    const yearPicker = new tempusDominus.TempusDominus(button, {
      restrictions: {
        // maxDate: new Date()
      },
      display: {
        viewMode: "years",
        icons: {
          previous: "fa fa-angle-left fs-1",
          next: "fa fa-angle-right fs-1"
        },
        components: {
          decades: true,
          year: true,
          month: false,
          date: false,
          hours: false,
          minutes: false,
          seconds: false
        }
      },
      defaultDate: props.currentDate || date.value
    });
    yearPicker.setValue = props.startDate
    yearPicker.subscribe(tempusDominus.Namespace.events.change, (e) => {
      const year = new Date(e.date).getFullYear()
      const startDate = new Date(year, 0, 1)
      const endDate = new Date(year, 11, 31);
      emits("update:date", { start: moment(startDate).format("DD-MM-YYYY"), end: moment(endDate).format("DD-MM-YYYY")})
    })
  }
}

onMounted(() => {
  nextTick(() => {
    moment.locale(locale.value);
    initDatePicker()
  })
})

</script>

<template>
  <button :id="id" type="button" class="btn btn-sm btn-flex btn-outline-primary fw-bolder shadow-sm border text-hover-white">
    <i class="fa fa-filter text-primary "></i>
    <span class="mx-4 text-capitalize"> {{ year }}</span>
    <i class="fa fa-angle-down text-primary fs-2"></i>
  </button>
</template>

<style>
.tempus-dominus-widget .toolbar {
  display: none !important;
}
</style>

`